// PlayShop : PAS DE PANIER PREPARE AVANT UN DROP (16/10/2026, PANIER-DROP).
// Decision de Lorenzo : « on ne doit pas pouvoir preparer son panier a l avance ».
// Fiche memoire : panier-drop-pas-de-panier-prepare.
//
// Le probleme mesure le 16/10 : /cart/add.js ACCEPTE un produit DENY a stock 0 (reponse 200). Shopify ne
// bloque qu au checkout ; a l ouverture d un drop, un panier prepare devient payable d un coup.
//
// Ce script, charge tot dans <head> (layout/theme.liquid), intercepte TOUT ajout au panier du theme :
// fetch, XMLHttpRequest et formulaire natif vers /cart/add. Pour un produit de DROP (metachamp
// playshop.panier_cles, pose par l edge fn panier-cles), il demande juste avant l ajout la section
// ps-panier-jeton par POST /cart/update.js (sections/ps-panier-jeton.liquid ; un POST n est jamais en cache) :
//   - pas encore ouvert pour ce client  -> ajout REFUSE, message « Ouverture le 24/10 à 17h » ;
//   - ouvert mais sans stock            -> ajout REFUSE, « Épuisé » (ou « le stock arrive » juste apres l heure) ;
//   - ouvert et en stock                -> la cle de SA vague est posee en propriete de ligne cachee `_ps_t`.
// La Validation Function (playshop-functions, preorder-gate) refuse au checkout toute ligne de drop sans
// la bonne cle : c est ELLE le vrai verrou (un appel direct a /cart/add.js passe ici, pas au checkout).
//
// ⛔ Un produit qui n est pas un drop n est JAMAIS touche (aucune propriete, aucun blocage) : sinon deux
//    ajouts du meme booster feraient deux lignes. La liste des drops est gardee 2 min par page.
// ⛔ Si la section ps-panier-jeton ne repond pas, l ajout part SANS cle (jamais bloque par une panne) : pour un
//    produit de drop, la Function le refusera au checkout avec « retire-le et remets-le ».
// Reactive aussi a l heure dite les boutons d ajout rapide rendus verrouilles ([data-ps-ouvre]).
// v4 (16/10/2026, DROP-GARANTIE) : journalise chaque tentative d ajout d un produit de drop et son resultat
// (edge fn panier-drop-journal, table panier_drop_journal) pour le filet du 21/10 (panier-drop-filet) ; une panne
// de la section au 2e chargement ne fait plus echouer l ajout (elle rejetait la promesse : l ajout partait en erreur).
(function () {
  'use strict';
  if (window.__psPanierDrop) return;
  window.__psPanierDrop = true;

  var NF = window.fetch ? window.fetch.bind(window) : null;
  var CLE = '_ps_t';
  var info = null, infoAt = 0;
  var TTL = 120000;
  var recentes = {};   // cles posees par nous il y a moins de 10 s (formulaire natif -> fetch)

  function estAjout(url) {
    try {
      var u = new URL(String(url), location.href);
      return u.origin === location.origin && /\/cart\/add(\.js|\.json)?$/.test(u.pathname);
    } catch (e) { return false; }
  }

  function charger(frais) {
    if (!frais && info && Date.now() - infoAt < TTL) return Promise.resolve(info);
    if (frais && info && Date.now() - infoAt < 3000) return Promise.resolve(info);
    // ⛔ POST et pas GET /cart?view=... : la page panier d un visiteur sans panier est mise en CACHE par
    // Shopify (mesure le 16/10 : a 13:10 elle rendait l heure de 12:55). Un POST n est jamais en cache.
    return NF('/cart/update.js', {
      method: 'POST', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: 'ps-panier-jeton' }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        var html = c && c.sections && c.sections['ps-panier-jeton'];
        var j = JSON.parse(html.slice(html.indexOf('{'), html.lastIndexOf('}') + 1));
        if (!j || typeof j.t !== 'number' || !j.d) throw new Error('pstoken');
        info = j; infoAt = Date.now();
        return j;
      });
  }

  function fmtOuverture(sec) {
    try {
      var d = new Date(sec * 1000);
      var p = new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d);
      var g = {}; p.forEach(function (x) { g[x.type] = x.value; });
      return g.day + '/' + g.month + ' à ' + g.hour + 'h' + (g.minute !== '00' ? g.minute : '');
    } catch (e) { return ''; }
  }

  // ----- Journal (16/10/2026, DROP-GARANTIE) -----
  // Chaque tentative d ajout d un produit de DROP et son resultat partent vers l edge fn panier-drop-journal
  // (sendBeacon, jamais attendu, jamais bloquant). Le filet du 21/10 (panier-drop-filet) y lit si des clients
  // AYANT DROIT se font refuser la cle. ⛔ Aucune donnee personnelle : ni id, ni e-mail, ni cle ; le palier
  // vu par la PAGE (d apres les tags de PS_TRACK_CTX) et celui vu par la SECTION, c est tout.
  var JOURNAL = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/panier-drop-journal';
  function vaguePage() {
    try {
      var c = window.PS_TRACK_CTX;
      if (!c) return 'inconnu';
      if (!c.customer_id) return 'invite';
      var t = c.vip;
      if (!Array.isArray(t)) return 'inconnu';
      if (t.indexOf('vip') >= 0 || t.indexOf('ps-tier-diamant') >= 0) return 'vip';
      if (t.indexOf('ps-tier-platine') >= 0) return 'platine';
      if (t.indexOf('ps-tier-or') >= 0) return 'or';
      return 'public';
    } catch (e) { return 'inconnu'; }
  }
  function journal(entrees, canal) {
    try {
      if (!entrees || !entrees.length) return;
      var vp = vaguePage();
      var corps = JSON.stringify({ e: entrees.slice(0, 20).map(function (x) { x.vp = vp; x.c = canal; return x; }) });
      // text/plain : pas de requete preliminaire CORS, le beacon part meme si la page se recharge.
      if (navigator.sendBeacon && navigator.sendBeacon(JOURNAL, new Blob([corps], { type: 'text/plain' }))) return;
      NF(JOURNAL, { method: 'POST', body: corps, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) { /* le journal ne casse jamais un ajout */ }
  }

  // Decision pour une liste d ids de variantes. Rend { bloque: message|null, cles: {id: cle}, log: [...] }.
  // `log` = une entree de journal par variante de DROP de l ajout (vide pour un produit normal).
  function decider(ids) {
    var dropConnus = [];
    return charger(false).then(function (j) {
      var drop = ids.filter(function (id) { return j.d[String(id)]; });
      dropConnus = drop;
      if (!drop.length) return { bloque: null, cles: {}, log: [] };
      return charger(true).then(function (j2) {
        var cles = {}, log = [];
        var ent = function (id, e, r) { return { v: String(id), n: e ? e.n : null, r: r, vs: j2.v || null, t: j2.t, o: e ? e.o : null, re: e && e.r ? 1 : 0 }; };
        for (var i = 0; i < drop.length; i++) {
          var e = j2.d[String(drop[i])];
          if (!e) continue;
          if (j2.t < e.o) {
            log.push(ent(drop[i], e, 'pas_ouvert'));
            // Un reassort a heure dite ne revele pas son heure (Lorenzo l annonce lui-meme).
            return { log: log, bloque: e.r ? '« ' + e.n + ' » n’est pas encore disponible.'
              : '« ' + e.n + ' » : ouverture le ' + fmtOuverture(e.o) + '. Tu pourras l’ajouter à ce moment-là.' };
          }
          if (!e.k) { log.push(ent(drop[i], e, 'pas_pour_toi')); return { log: log, bloque: '« ' + e.n + ' » n’est pas encore ouvert pour toi.' }; }
          if (!e.a) {
            var arrive = (j2.t - e.o < 600);
            log.push(ent(drop[i], e, arrive ? 'stock' : 'epuise'));
            return { log: log, bloque: arrive
              ? '« ' + e.n + ' » : le stock arrive, réessaie dans quelques secondes.'
              : '« ' + e.n + ' » est épuisé.' };
          }
          cles[String(drop[i])] = e.k;
          log.push(ent(drop[i], e, 'cle'));
        }
        return { bloque: null, cles: cles, log: log };
      });
    }).then(null, function () {
      // Panne de la section : l ajout part SANS cle (jamais bloque). Si la liste des drops etait connue, on
      // journalise la panne pour les variantes de drop concernees (le filet les compte).
      var log = [];
      try {
        // Liste des drops inconnue (1er chargement en panne) : on journalise toutes les variantes de l ajout, le
        // filet ne retient que celles du drop.
        var connus = info && info.d ? ids.filter(function (id) { return info.d[String(id)]; }) : (dropConnus.length ? dropConnus : ids);
        log = connus.map(function (id) { var e = info && info.d ? info.d[String(id)] : null; return { v: String(id), n: e ? e.n : null, r: 'panne', re: e && e.r ? 1 : 0 }; });
      } catch (x) { /* */ }
      return { bloque: null, cles: {}, panne: true, log: log };
    });
  }

  // ----- Lire / ecrire les articles d un corps de requete -----
  // Rend { ids: [...], poser: function(cles) -> nouveau corps } ou null si format inconnu.
  function analyser(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var f = body;
      var ids = [], cles2pos = [];
      if (f.get('id')) { ids.push(f.get('id')); cles2pos.push({ id: f.get('id'), nom: 'properties[' + CLE + ']' }); }
      f.forEach(function (v, k) {
        var m = /^items\[(\d+)\]\[id\]$/.exec(k);
        if (m) { ids.push(v); cles2pos.push({ id: v, nom: 'items[' + m[1] + '][properties][' + CLE + ']' }); }
      });
      return {
        ids: ids,
        dejaCle: cles2pos.some(function (c) { var x = f.get(c.nom); return x && recentes[x]; }),
        poser: function (cles) { cles2pos.forEach(function (c) { if (cles[String(c.id)]) f.set(c.nom, cles[String(c.id)]); }); return f; },
      };
    }
    if (typeof body === 'string') {
      var t = body.trim();
      if (t.charAt(0) === '{') {
        var o; try { o = JSON.parse(t); } catch (e) { return null; }
        var items = Array.isArray(o.items) ? o.items : (o.id ? [o] : []);
        return {
          ids: items.map(function (it) { return it.id; }),
          dejaCle: false,
          poser: function (cles) {
            items.forEach(function (it) {
              var k = cles[String(it.id)];
              if (k) { it.properties = it.properties || {}; it.properties[CLE] = k; }
            });
            return JSON.stringify(o);
          },
        };
      }
      var usp = new URLSearchParams(t);
      var a = analyser(usp);
      if (!a) return null;
      return { ids: a.ids, dejaCle: a.dejaCle, poser: function (cles) { return a.poser(cles).toString(); } };
    }
    return null;
  }

  // ----- Message a l ecran -----
  function toast(msg) {
    try {
      var el = document.getElementById('ps-panier-drop-toast');
      if (!el) {
        el = document.createElement('div');
        el.id = 'ps-panier-drop-toast';
        el.setAttribute('role', 'alert');
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,460px);padding:14px 18px;border-radius:12px;background:#111827;color:#fff;font:600 15px/1.35 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.35);text-align:center';
        document.body.appendChild(el);
      }
      el.textContent = msg;
      el.style.display = 'block';
      clearTimeout(el._t);
      el._t = setTimeout(function () { el.style.display = 'none'; }, 6000);
    } catch (e) { /* */ }
  }

  function reponseRefus(msg) {
    var corps = JSON.stringify({ status: 422, message: 'Ajout impossible', description: msg });
    return new Response(corps, { status: 422, headers: { 'Content-Type': 'application/json' } });
  }

  // ----- 1) fetch -----
  if (NF) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' || input instanceof URL ? String(input) : (input && input.url);
        var methode = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (methode === 'POST' && estAjout(url) && init && init.body != null && !(input instanceof Request)) {
          var a = analyser(init.body);
          if (a && a.ids.length && !a.dejaCle) {
            return decider(a.ids).then(function (d) {
              journal(d.log, 'fetch');
              if (d.bloque) { toast(d.bloque); return reponseRefus(d.bloque); }
              var corps = Object.keys(d.cles).length ? a.poser(d.cles) : init.body;
              var init2 = {}; for (var k in init) init2[k] = init[k];
              init2.body = corps;
              return NF(input, init2);
            });
          }
        }
      } catch (e) { /* jamais casser un appel */ }
      return NF(input, init);
    };
  }

  // ----- 2) XMLHttpRequest (filet : le theme passe par fetch) -----
  try {
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__psM = String(m || '').toUpperCase(); this.__psU = u; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      try {
        if (xhr.__psM === 'POST' && estAjout(xhr.__psU) && body != null) {
          var a = analyser(body);
          if (a && a.ids.length && !a.dejaCle) {
            decider(a.ids).then(function (d) {
              journal(d.log, 'xhr');
              if (d.bloque) toast(d.bloque);
              XS.call(xhr, d.bloque ? body : (Object.keys(d.cles).length ? a.poser(d.cles) : body));
            });
            return;
          }
        }
      } catch (e) { /* */ }
      return XS.apply(xhr, arguments);
    };
  } catch (e) { /* */ }

  // ----- 3) formulaire NATIF vers /cart/add (aucun script ne l a intercepte) -----
  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || ev.defaultPrevented || form.__psOk) return;
    if (!estAjout(form.getAttribute('action') || '')) return;
    var fd; try { fd = new FormData(form); } catch (e) { return; }
    var a = analyser(fd);
    if (!a || !a.ids.length) return;
    ev.preventDefault();
    decider(a.ids).then(function (d) {
      journal(d.log, 'form');
      if (d.bloque) { toast(d.bloque); return; }
      Object.keys(d.cles).forEach(function (id) {
        var nom = form.querySelector('input[name="id"]') ? 'properties[' + CLE + ']' : null;
        if (!nom) return;
        var inp = form.querySelector('input[name="' + nom + '"]');
        if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = nom; form.appendChild(inp); }
        inp.value = d.cles[id];
        recentes[d.cles[id]] = 1; setTimeout(function () { delete recentes[d.cles[id]]; }, 10000);
      });
      form.__psOk = true;
      HTMLFormElement.prototype.submit.call(form);
    });
  });

  // ----- 4) Reactiver a l heure dite les ajouts rapides verrouilles -----
  function reveiller() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-ps-ouvre]').forEach(function (b) {
      var t = parseInt(b.getAttribute('data-ps-ouvre'), 10);
      if (!t || now < t) return;
      b.removeAttribute('data-ps-ouvre');
      if (b.getAttribute('data-ps-dispo') !== '1') return; // pas de stock rendu : la page se rechargera (countdown)
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      var st = b.querySelector('.ps-card__cta-variant-state');
      if (st) { st.textContent = b.getAttribute('data-ps-prix') || ''; st.removeAttribute('style'); }
    });
  }
  function demarrer() { reveiller(); setInterval(reveiller, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
